/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import { MenuItem } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import React, { useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { endOfMonth, format, parseISO, startOfMonth } from 'date-fns'
import queryString from 'query-string'
import Icon from '@mdi/react'
import { mdiFilterMultiple, mdiMagnify, mdiMicrosoftExcel } from '@mdi/js'

import consts from '../../../util/consts'
import { useQueryParams } from '../../../util/utils'
import { makeRelatory } from '../TeamProdutivityRelatoryActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import colors from '../../../assets/colors'

const parseDate = (value, fallback) => {
  if (!value) return fallback
  const parsed = parseISO(value)
  return Number.isNaN(parsed.getTime()) ? fallback : parsed
}

export default function Filter(props) {
  const { classes } = props

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const query = useQueryParams(location.search)

  const teams = useSelector(state => state.team_produtivity_relatory.teams)
  const serviceTypes = useSelector(
    state => state.team_produtivity_relatory.services_types
  )

  const styles = filterStylesComponents()

  const [open, setOpen] = useState(false)
  const [form, setForm] = useState({
    team: query.team || '',
    service_type: query.service_type || '',
    date_start: parseDate(query.date_start, startOfMonth(new Date())),
    date_end: parseDate(query.date_end, endOfMonth(new Date())),
  })

  const handleOpen = () => setOpen(!open)

  // Escreve os filtros na URL. O index observa location.search e refaz a busca.
  const applyFilters = () => {
    const params = {
      team: form.team || undefined,
      service_type: form.service_type || undefined,
      date_start: form.date_start
        ? format(form.date_start, 'yyyy-MM-dd')
        : undefined,
      date_end: form.date_end ? format(form.date_end, 'yyyy-MM-dd') : undefined,
      page: 1,
      rows: query.rows || consts.DEFAULT_PAGINATION,
    }

    history.push(`${location.pathname}?${queryString.stringify(params)}`)
  }

  const handleRelatory = e => {
    e.preventDefault()
    dispatch(
      makeRelatory({
        ...form,
        date_start: form.date_start
          ? format(form.date_start, 'yyyy-MM-dd')
          : null,
        date_end: form.date_end ? format(form.date_end, 'yyyy-MM-dd') : null,
      })
    )
  }

  return (
    <BaseFilter>
      <Grid container spacing={2}>
        <Grid item container spacing={1} xs={12} sm={6} alignItems="center">
          <Grid item xs={12} sm={4}>
            <KeyboardDatePicker
              clearable
              value={form.date_start}
              label="Data Inicial"
              fullWidth
              views={['date']}
              clearLabel="Limpar"
              invalidDateMessage="Data inválida"
              autoOk
              onChange={date => setForm({ ...form, date_start: date })}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <KeyboardDatePicker
              clearable
              value={form.date_end}
              label="Data Final"
              fullWidth
              views={['date']}
              clearLabel="Limpar"
              invalidDateMessage="Data inválida"
              autoOk
              onChange={date => setForm({ ...form, date_end: date })}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <IconButton className={styles.btnAdd} onClick={applyFilters}>
              <Icon path={mdiMagnify} size={1} />
              Pesquisar
            </IconButton>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} container className={styles.areaButtons}>
          <IconButton className={styles.btnMoreFilters} onClick={handleOpen}>
            <Icon path={mdiFilterMultiple} size={1} color={colors.secondary} />
            Filtros
          </IconButton>

          <IconButton className={styles.btnAdd} onClick={handleRelatory}>
            <Icon path={mdiMicrosoftExcel} size={1} />
            Download
          </IconButton>
        </Grid>
      </Grid>

      <BaseFilterModal open={open} handleOpen={handleOpen} title="FILTROS">
        <Grid
          xs={12}
          item
          container
          style={{ width: '420px' }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} style={{ fontSize: '16px' }}>
            Utilize os campos abaixo para encontrar uma equipe
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              onChange={e => setForm({ ...form, team: e.target.value })}
              select
              label="Equipes"
              className={classes.inputFilter}
              fullWidth
              value={form.team}
            >
              <MenuItem key="" value="">
                Selecione...
              </MenuItem>
              {teams?.map(team => (
                <MenuItem key={team.id} value={team.id}>
                  {team.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              onChange={e => setForm({ ...form, service_type: e.target.value })}
              select
              label="Tipo de Serviço"
              className={classes.inputFilter}
              fullWidth
              value={form.service_type}
            >
              <MenuItem key="" value="">
                Selecione...
              </MenuItem>
              {serviceTypes?.map(serviceType => (
                <MenuItem key={serviceType.id} value={serviceType.id}>
                  {serviceType.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <KeyboardDatePicker
              clearable
              value={form.date_start}
              label="Data Inicial"
              fullWidth
              views={['date']}
              clearLabel="Limpar"
              invalidDateMessage="Data inválida"
              autoOk
              onChange={date => setForm({ ...form, date_start: date })}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <KeyboardDatePicker
              clearable
              value={form.date_end}
              label="Data Final"
              fullWidth
              views={['date']}
              clearLabel="Limpar"
              invalidDateMessage="Data inválida"
              autoOk
              onChange={date => setForm({ ...form, date_end: date })}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: '1em' }}
          >
            <Button
              className={styles.btnAdd}
              onClick={() => {
                applyFilters()
                handleOpen()
              }}
            >
              <SearchIcon />
              Pesquisar
            </Button>
          </Grid>
        </Grid>
      </BaseFilterModal>
    </BaseFilter>
  )
}
